// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountStatusDto } from './IAccountStatusDto';
import {
    IAccountStatusDtoFromJSON,
    IAccountStatusDtoFromJSONTyped,
    IAccountStatusDtoToJSON,
    IAccountStatusDtoToJSONTyped,
} from './IAccountStatusDto';

/**
 * 
 * @export
 * @interface IAccountDto
 */
export interface IAccountDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    on_deposit_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    live_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    parent_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    root_account_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IAccountDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IAccountDto
     */
    modified_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountDto
     */
    leaf_node?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    routing_transit_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    account_type?: IAccountDtoAccountTypeEnum;
    /**
     * 
     * @type {Set<IAccountStatusDto>}
     * @memberof IAccountDto
     */
    account_statuses?: Set<IAccountStatusDto>;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    latest_status?: IAccountDtoLatestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    account_category?: IAccountDtoAccountCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountDto
     */
    is_forfeited?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    replacement_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountDto
     */
    account_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountDto
     */
    plan_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IAccountDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IAccountDtoLatestStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum IAccountDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IAccountDto interface.
 */
export function instanceOfIAccountDto(value: object): value is IAccountDto {
    return true;
}

export function IAccountDtoFromJSON(json: any): IAccountDto {
    return IAccountDtoFromJSONTyped(json, false);
}

export function IAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'number': json['number'] == null ? undefined : json['number'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'on_deposit_balance': json['on_deposit_balance'] == null ? undefined : json['on_deposit_balance'],
        'live_balance': json['live_balance'] == null ? undefined : json['live_balance'],
        'parent_account_id': json['parent_account_id'] == null ? undefined : json['parent_account_id'],
        'root_account_id': json['root_account_id'] == null ? undefined : json['root_account_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'modified_at': json['modified_at'] == null ? undefined : (new Date(json['modified_at'])),
        'leaf_node': json['leaf_node'] == null ? undefined : json['leaf_node'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_statuses': json['account_statuses'] == null ? undefined : (new Set((json['account_statuses'] as Array<any>).map(IAccountStatusDtoFromJSON))),
        'latest_status': json['latest_status'] == null ? undefined : json['latest_status'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'is_forfeited': json['is_forfeited'] == null ? undefined : json['is_forfeited'],
        'replacement_account_id': json['replacement_account_id'] == null ? undefined : json['replacement_account_id'],
        'account_path': json['account_path'] == null ? undefined : json['account_path'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
    };
}

export function IAccountDtoToJSON(json: any): IAccountDto {
    return IAccountDtoToJSONTyped(json, false);
}

export function IAccountDtoToJSONTyped(value?: IAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'number': value['number'],
        'available_balance': value['available_balance'],
        'on_deposit_balance': value['on_deposit_balance'],
        'live_balance': value['live_balance'],
        'parent_account_id': value['parent_account_id'],
        'root_account_id': value['root_account_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'modified_at': value['modified_at'] == null ? undefined : ((value['modified_at']).toISOString()),
        'leaf_node': value['leaf_node'],
        'routing_transit_number': value['routing_transit_number'],
        'account_type': value['account_type'],
        'account_statuses': value['account_statuses'] == null ? undefined : (Array.from(value['account_statuses'] as Set<any>).map(IAccountStatusDtoToJSON)),
        'latest_status': value['latest_status'],
        'account_category': value['account_category'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'employee_id': value['employee_id'],
        'external_identifier': value['external_identifier'],
        'is_forfeited': value['is_forfeited'],
        'replacement_account_id': value['replacement_account_id'],
        'account_path': value['account_path'],
        'plan_id': value['plan_id'],
    };
}

